<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Contabili
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col cols="2">
          <v-switch
            v-model="soloNonSaldati"
            label="Solo Non Saldati"
            class="ml-4"
            inset
            hide-details
          ></v-switch
        ></v-col>
        <v-col cols="2">
          <v-switch
            v-model="raggruppaPerCliente"
            label="Raggruppa per cliente"
            class="ml-4"
            inset
            hide-details
          ></v-switch>
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            v-model="cliente"
            :items="clienti"
            label="Cliente"
            item-text="nome"
            item-value="iva"
            outlined
            hide-details
          ></v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-select
            v-model="periodo"
            :items="periodoItems"
            label="Periodo"
            item-text="nome"
            item-value="value"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
            v-model="tipo"
            :items="tipoItems"
            label="Tipo"
            item-text="nome"
            item-value="value"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-switch
            v-model="modalitaSelezioneFattura"
            label="Seleziona per Fattura"
            class="ml-4"
            inset
            hide-details
            @change="selezioneFattura = {}"
          ></v-switch>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
      <v-row no-gutters class="mt-4">
        <v-col cols="2"> Cliente </v-col>
        <v-col cols="1"> Data </v-col>
        <v-col cols="1"> Importo </v-col>
        <v-col cols="1"> Metodo </v-col>
        <v-col cols="1"> Documento </v-col>
        <v-col cols="1"> Conteggio </v-col>

        <v-col cols="1"> Ordine # </v-col>
        <v-col cols="1"> Saldato </v-col>
        <v-col cols="1"> Residuo </v-col>
        <v-col cols="2"> Note </v-col>
      </v-row>
      <v-divider class="mt-4 mb-6"></v-divider>
      <template>
        <template v-if="raggruppaPerCliente">
          <div v-for="(group, cliente) in groupedByCliente" :key="cliente">
            <v-row class="mb-1" align="center">
              <v-col cols="auto" class="font-weight-bold">{{
                getCliente(cliente).nome
              }}</v-col>
              <v-col cols="auto">
                <v-btn icon small @click="stampaEstrattoContoCliente(cliente)" title="Stampa estratto conto">
                  <v-icon small>mdi-file-pdf-box</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" v-if="group.countAperti > 0">
                <v-chip
                  small
                  outlined
                  color="grey darken-1"
                  title="Somma dei residui effettivi (non l'importo pieno) su Debiti non saldati e Fatture Anticipate non ancora pagate, nel periodo/filtro selezionato"
                >
                  <v-icon left small>mdi-clock-alert-outline</v-icon>
                  {{ group.countAperti }} apert{{ group.countAperti === 1 ? "o" : "i" }} — da incassare: 
                  <span class="black--text font-weight-medium ml-1 mr-2">€ {{ group.residuoAperto.toFixed(2) }}</span>
                  di cui
                  <span v-if="group.residuoApertoVerde > 0" class="green--text ml-2">
                    verde € {{ group.residuoApertoVerde.toFixed(2) }}
                  </span>
                  <span v-if="group.residuoApertoBlu > 0" class="blue--text ml-2">
                    blu € {{ group.residuoApertoBlu.toFixed(2) }}
                  </span>
                </v-chip>
              </v-col>
              <v-col cols="auto" v-if="group.creditoDisponibile > 0">
                <v-chip
                  small
                  outlined
                  color="grey darken-1"
                  title="Credito ancora disponibile (Pagamento Cliente o Fattura di Copertura) non ancora assegnato a nessun debito, nel periodo/filtro selezionato"
                >
                  <v-icon left small color="teal darken-1">mdi-cash-plus</v-icon>
                  {{ group.countCrediti }} credit{{ group.countCrediti === 1 ? "o" : "i" }} —
                  <span class="teal--text text--darken-1">€ {{ group.creditoDisponibile.toFixed(2) }}</span>
                </v-chip>
              </v-col>
            </v-row>
            <div v-for="(monthGroup, month) in group.contabili" :key="month">
              <v-row class="mb">
                <v-col cols="12" class="font-weight-light"
                  ><u>{{ month }}</u></v-col
                >
              </v-row>
              <template v-for="contabile in monthGroup.contabili">
                <v-lazy :options="{ threshold: 0.7 }" :key="contabile.id">
                  <contabile
                    @new_insert="hardRefreshList"
                    @toggle-selezione-fattura="onToggleSelezioneFattura"
                    :contabile="contabile"
                    :modalita-selezione-fattura="modalitaSelezioneFattura"
                    :cliente-selezionato-fattura="clienteSelezioneFattura"
                    :selezionato-fattura="!!selezioneFattura[contabile.id]"
                  ></contabile>
                </v-lazy>
              </template>
              <v-row no-gutters class="mt-2 text-caption">
                <v-col cols="5" offset="3">
                  <span title="Fatturato del mese: Debiti + IVA delle Fatture Anticipate. Esclude sempre i Pagamenti Cliente (sono incassi, non fatturato) — per quanto ancora scoperto vedi il chip in testa">
                    Tot Mese: € {{ monthGroup.totale.toFixed(2) }}
                  </span>
                  <span
                    class="green--text mx-2"
                    title="Quota verde del Tot Mese"
                  >
                    Fatturato verde € {{ monthGroup.tot_verde.toFixed(2) }}</span
                  >
                  <span
                    class="blue--text"
                    title="Quota blu del Tot Mese"
                  >
                    Fatturato blu € {{ monthGroup.tot_blu.toFixed(2) }}</span
                  >
                </v-col>
              </v-row>
            </div>
            <v-row no-gutters class="mt-4">
              <v-col cols="5" offset="3">
                <b title="Fatturato dell'intero periodo: Debiti + IVA delle Fatture Anticipate. Esclude sempre i Pagamenti Cliente (sono incassi, non fatturato) — per quanto ancora scoperto vedi il chip in testa">Totale: € {{ group.totale.toFixed(2) }}</b>
                <span
                  class="green--text mx-2"
                  title="Quota verde sull'intero periodo: l'imponibile di una Fattura Anticipata/Posticipata è spostato qui da blu (regolarizza ritiri verdi già avvenuti)"
                >
                  Verde € {{ group.tot_verde.toFixed(2) }}</span
                >
                <span
                  class="blue--text"
                  title="Quota blu sull'intero periodo: include l'imponibile+IVA di ogni Fattura Anticipata/Posticipata"
                >
                  Blu € {{ group.tot_blu.toFixed(2) }}</span
                >
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-6"></v-divider>
          </div>
        </template>
        <template v-else>
          <div v-for="(group, day) in groupedByDay" :key="day">
            <v-row class="mb-1">
              <v-col cols="12" class="font-weight-bold">{{ day }}</v-col>
            </v-row>
            <template v-for="contabile in group.contabili">
              <v-lazy :options="{ threshold: 0.5 }" :key="contabile.id">
                <contabile
                  @new_insert="hardRefreshList"
                  @toggle-selezione-fattura="onToggleSelezioneFattura"
                  :key="contabile.id"
                  :contabile="contabile"
                  :modalita-selezione-fattura="modalitaSelezioneFattura"
                  :cliente-selezionato-fattura="clienteSelezioneFattura"
                  :selezionato-fattura="!!selezioneFattura[contabile.id]"
                ></contabile>
              </v-lazy>
            </template>
            <v-row no-gutters class="">
              <v-col cols="3" offset="4">
                <v-divider class="mb-2" />
                <b>{{ soloNonSaldati ? 'Tot. non saldati' : 'Totale' }}: € {{ group.totale.toFixed(2) }}</b>
                <span class="green--text mx-2"
                  >€ {{ group.tot_verde.toFixed(2) }}</span
                >
                <span class="blue--text">€ {{ group.tot_blu.toFixed(2) }}</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-6"></v-divider>
          </div>
        </template>
      </template>
      <template v-if="contabili.length == 0">
        <v-row no-gutters>
          <v-col cols="12" class="text-center">
            Nessun Pagamento Registrato
          </v-col>
        </v-row>
      </template>
    </v-card-text>
    <v-btn fab fixed bottom right color="green" class="ma-12" @click="$refs.nuova_contabile.open()">
      <v-icon color="white">mdi-plus</v-icon>
    </v-btn>
    <nuova_contabile
      noButton
      ref="nuova_contabile"
      @new_insert="hardRefreshList"
    ></nuova_contabile>
    <v-snackbar
      :value="modalitaSelezioneFattura && listaSelezioneFattura.length > 0"
      :timeout="-1"
      bottom
      color="blue darken-2"
      multi-line
    >
      {{ listaSelezioneFattura.length }} movimenti selezionati — totale € {{ totaleSelezioneFattura.toFixed(2) }}
      <template v-slot:action>
        <v-btn text @click="annullaSelezioneFattura">Annulla</v-btn>
        <v-btn text outlined @click="apriCoperturaFattura">Crea copertura con Fattura</v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialogInattivita" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Inattività</v-card-title>
        <v-card-text
          >Sei ancora lì? Premi il pulsante per continuare.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="continua_navigazione"
            >Continua</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import nuova_contabile from "./nuova_contabile.vue";
import contabile from "./contabile_desktop_element.vue";
import contabile_main_mixin from "../mixin/contabili_main_mixin";
export default {
  components: {
    nuova_contabile,
    contabile,
  },
  mixins: [contabile_main_mixin],
  data() {
    return {
      // "Crea coperture con Fattura": selezione multi-riga di debiti verdi
      // aperti, per proporre poi una Fattura Anticipata/Posticipata che li
      // eroda esattamente. Chiave = id contabile, valore = il contabile
      // stesso (comodo per ricavare cliente/importo senza rileggerlo).
      modalitaSelezioneFattura: false,
      selezioneFattura: {},
    };
  },
  computed: {
    listaSelezioneFattura() {
      return Object.values(this.selezioneFattura);
    },
    totaleSelezioneFattura() {
      return this.listaSelezioneFattura.reduce(
        (tot, c) => tot + Math.abs(c.importo || 0),
        0
      );
    },
    // Una fattura è sempre di un solo cliente: il primo movimento
    // selezionato "blocca" il cliente, le righe di altri clienti restano
    // disabilitate finché la selezione non si svuota (vedi
    // contabile_desktop_element.vue).
    clienteSelezioneFattura() {
      return this.listaSelezioneFattura[0]?.cliente || null;
    },
  },
  methods: {
    onToggleSelezioneFattura(contabile) {
      const nuova = { ...this.selezioneFattura };
      if (nuova[contabile.id]) {
        delete nuova[contabile.id];
      } else {
        nuova[contabile.id] = contabile;
      }
      this.selezioneFattura = nuova;
    },
    annullaSelezioneFattura() {
      this.selezioneFattura = {};
      this.modalitaSelezioneFattura = false;
    },
    apriCoperturaFattura() {
      const debiti = this.listaSelezioneFattura.map((c) => ({
        id: c.id,
        residuo: Math.abs(c.importo || 0),
      }));
      this.$refs.nuova_contabile.apriPerCoperturaFattura(
        this.clienteSelezioneFattura,
        debiti
      );
      this.selezioneFattura = {};
      this.modalitaSelezioneFattura = false;
    },
  },
};
</script>